import ObjectCreationValidator from '@/entities/validators/ObjectCreationValidator'
import { ContactInfoI } from '@/modules/invoice/types/api/ContactInfo'

export default class ContactInfo {
  company: string
  addressLine1: string
  addressLine2: string
  city: string
  phone: string
  constructor(data: ContactInfoI) {
    this.company = data.company
    this.addressLine1 = data.addressLine1
    this.addressLine2 = data.addressLine2
    this.city = data.city
    this.phone = data.phone

    ObjectCreationValidator.validate(this)
  }
}
